import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { generateRandomString } from "utils/helper";
import * as services from "../services/companyApi";
import { setCurrentCompanyProfile, setIsLoading } from "../slices/companySlice";
import useOptions from "features/masterData/hooks/useOptions";

function useCompanyProfileView(props) {
  const { onEdit = () => { } } = props;
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.company.isLoading);
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const currentCompanyProfile = useSelector(
    (state) => state.company.currentCompanyProfile
  );

  const {
    companyTypeOptions = [],
    getMstCompanyTypeOptions = () => { },
  } = useOptions();

  const getCompany = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      if (currentCompany) {
        const response = await services.getCompany({
          requestId: generateRandomString(),
          companyId: currentCompany,
        });
        dispatch(setCurrentCompanyProfile(response.data));
      }
    } catch (error) {
      // alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, dispatch]);

  useEffect(() => {
    if (currentCompany && typeof currentCompany !== "object") {
      getMstCompanyTypeOptions?.()
      getCompany();
    }
  }, [currentCompany, getCompany]);

  return { isLoading, currentCompanyProfile, onEdit, companyTypeOptions };
}

export default useCompanyProfileView;
